import VueRouter from "vue-router";
import routes from "./routes";
import store from '../store/store';

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior() {
    return {x: 0, y: 0};
  }
});

router.beforeEach((to, from, next) => {
  if (to.path === '/pin') {
    store.commit('ui/HIDE_MENU');
    next();
    return;
  }

  if (store.getters['auth/isAuth'] || to.path === '/authenticated') {
    store.commit('ui/HIDE_MENU');
    next();
  } else {
    store.dispatch('auth/initialize', {
      callback: () => {
        store.commit('ui/HIDE_OVERLAY');
        next(to.path);
      }
    }).catch(err => {
      /* eslint-disable */
      console.log(err);
    });
  }
});

export default router;
